// const backendDomain = "http://192.168.1.111/SHLDR"
const backendDomain = "https://shldr.oakyaitservices.com/api"
// const backendDomain = "https://oakyafoodaccounts.sanjayghodawat.co.in/api"           

const SummaryApi = {
    createServices : {
        url : `${backendDomain}/service/service_create.php`,
        method : "POST"
    },
    updateStudent : {
        url : `${backendDomain}/student/student_update.php`,
        method : "POST"
    },
    getAllServices : {    
        url : `${backendDomain}/service/service_retrieve.php`,
        method : "GET"
    },    
    serviceImg:{
      url: `${backendDomain}/service/images`,
    },                                 
}     
                                                                                         
export default SummaryApi;     

     








